import React, { useEffect, useState } from "react";
import ListItem from "../../../components/ListItem";
import t from "../../../helpers/t";
import { moment } from "../../../../../vendor";
import { Biscuit } from "../../../../utils";
import { insurancesActions, useSelector } from "inbooma-api";
import InsuranceItem from "./InsuranceItem";

const InsurancesList = (props) => {
  const { dispatch, insurances, currentUrl, showNotification } = props;
  //  const insurancesData = [];

  /*    useEffect(() => {

        if (editPending === null || _editInsurance.success === '') return;

        if (_editInsurance.success === true) {

            // show notification
        } else {
            // show notification
        }
        setEditPending(null);
    },[_editInsurance]);*/

  return (
    <>
      <div
        className="inb-c-listing off-canvas-content"
        id="inb-c-main-insurances"
        style={{ minHeight: "1150px" }}
      >
        {typeof insurances !== "undefined" &&
          insurances.length > 0 &&
          insurances.map((insurance, index) => {
            let isAbo = false;
            if (insurance.description.substring(0, 3) === "Abo") {
              isAbo = true;
            }
            return (
              <>
                <InsuranceItem
                  insurance={insurance}
                  index={index}
                  isAbo={isAbo}
                  dispatch={dispatch}
                  currentUrl={currentUrl}
                  showNotification={showNotification}
                />
              </>
            );
          })}
      </div>
    </>
  );
};
export default InsurancesList;
